import { useEffect, useState } from "react";
import api from "../../api/axiosInstance";

import NavigationTabBar from '../../components/navigation/NavigationTabBar';
import FooterSection from '../../components/navigation/FooterSection';
import JobCard from "./components/JobCard";
import JobFilters from "./components/JobFilters";

const Jobs = () => {
  const [jobs, setJobs] = useState([]);
  const [filters, setFilters] = useState({
    keyword: "",
    location: "",
    type: ""
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const res = await api.get("/api/jobs");
        setJobs(res.data.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchJobs();
  }, []);

  const filteredJobs = jobs.filter((job) =>
    (!filters.keyword ||
      job.title?.toLowerCase().includes(filters.keyword.toLowerCase())) &&
    (!filters.location ||
      job.location?.toLowerCase().includes(filters.location.toLowerCase())) &&
    (!filters.type || job.employment_type === filters.type)
  );

  return (
      <div className="min-h-screen bg-background">
         <NavigationTabBar isAuthenticated={false} />
            <main className="pt-16">
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">

      {/* HERO */}
      <section className="bg-blue-600 text-white py-14">
        <div className="max-w-6xl mx-auto px-4">
          <h1 className="text-4xl font-bold mb-2">
            Find Your Next Dream Job 🚀
          </h1>
          <p className="text-blue-100 text-lg">
            Verified jobs. Official links. Zero noise.
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <div className="max-w-6xl mx-auto px-4 py-8">

          <JobFilters filters={filters} setFilters={setFilters} />

        {loading && (
          <p className="text-center text-gray-500 mt-10">
            Loading jobs...
          </p>
        )}

        {!loading && filteredJobs.length === 0 && (
          <p className="text-center text-gray-500 mt-10">
            No jobs found. Try different filters.
          </p>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
          {filteredJobs.map((job, index) => (
            <JobCard key={index} job={job} />
          ))}
        </div>
      </div>
    </div>
     </main>
     <FooterSection />
    </div>
  );
};

export default Jobs;